<template>
  <div class="Trio-results">
    <div class="Trio-results-box">
      <p>Con los datos introducidos no hay hipotecas viables.</p>
      <p>Prueba a modificar tu información e inténtalo de nuevo.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "noResults",
};
</script>